module.exports = __webpack_public_path__ + "static/media/CSK-horiz-mobile-default@2x.01639c81.png";